import React from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../ui/card';
import { Button } from '../ui/button';
import { Trash2 } from 'lucide-react';

export default function SettingsTab({ onDeleteTestUsers, onClearTestData }) {
  return (
    <div className="space-y-6" data-testid="settings-tab">
      <h2 className="text-xl font-bold text-white">Admin Settings & Cleanup</h2>

      <Card className="bg-slate-800 border-slate-700">
        <CardHeader>
          <CardTitle className="text-white flex items-center gap-2">
            <Trash2 className="h-5 w-5 text-red-400" />
            Data Cleanup
          </CardTitle>
          <CardDescription className="text-slate-400">
            Remove test users and clear test data from the database
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="p-4 bg-slate-700/50 rounded-lg">
            <div className="flex items-center justify-between">
              <div>
                <h3 className="text-white font-medium">Delete Test Users</h3>
                <p className="text-slate-400 text-sm mt-1">
                  Removes all users with "test" in email or @test.com/@example.com domains
                </p>
              </div>
              <Button onClick={onDeleteTestUsers} variant="destructive" className="bg-red-600 hover:bg-red-500">
                <Trash2 className="h-4 w-4 mr-2" />Delete Test Users
              </Button>
            </div>
          </div>

          <div className="p-4 bg-slate-700/50 rounded-lg">
            <div className="flex items-center justify-between">
              <div>
                <h3 className="text-white font-medium">Clear Test Data</h3>
                <p className="text-slate-400 text-sm mt-1">
                  Clears usage logs, activity logs, email history, AI plans, and payment history
                </p>
              </div>
              <Button onClick={onClearTestData} variant="destructive" className="bg-orange-600 hover:bg-orange-500">
                <Trash2 className="h-4 w-4 mr-2" />Clear Test Data
              </Button>
            </div>
          </div>
        </CardContent>
      </Card>

      <Card className="bg-slate-800/50 border-slate-700">
        <CardContent className="p-6">
          <div className="text-center text-slate-400">
            <p className="text-sm">These actions are irreversible. Use with caution.</p>
            <p className="text-xs mt-2">Only run these in development/preview environments, not production.</p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
